export default ({ strings }) => ({
    visible: false,
    blog: {
        visible: false,
        destination: null,
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_vertical_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_vertical_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_vertical_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_vertical_solutions_label,
        options: [
            {
                link: "/construction/",
                label: strings.nav_vertical_industry_construction_label
            },
            {
                link: "/consulting/",
                label: strings.nav_vertical_industry_consulting_label
            },
            {
                link: "/foodservice/",
                label: strings.nav_vertical_industry_foodservice_label
            },
            {
                link: "/healthcare/",
                label: strings.nav_vertical_industry_healthcare_label
            },
            {
                link: "/hospitality/",
                label: strings.nav_vertical_industry_hospitality_label
            },
            {
                link: "/manufacturing/",
                label: strings.nav_vertical_industry_manufacturing_label
            },
            {
                link: "/retail/",
                label: strings.nav_vertical_industry_retail_label
            }
        ]
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_vertical_enterprise_label
    }
});
